import { notify } from '../helpers/BugsnagClient';

const debug = require('debug')('jp:clientMiddleware');

export default function clientMiddleware(client) {
  return ({ dispatch, getState }) => next => action => {
    if (typeof action === 'function') {
      return action(dispatch, getState, client);
    }

    const {
      promise,
      types,
      shouldCallApi = () => __SERVER__ || true,
      onApiCallSkipped = () => {},
      onRequestDispatched = () => {},
      onSuccessDispatched = () => {},
      onFailureDispatched = () => {},
      ...rest
    } = action; // eslint-disable-line no-redeclare
    if (!promise) {
      return next(action);
    }

    const [REQUEST, SUCCESS, FAILURE] = types;

    if (!shouldCallApi(getState())) {
      onApiCallSkipped(rest, dispatch, getState());
      return undefined;
    }

    next({ ...rest, type: REQUEST });

    onRequestDispatched(rest, dispatch, getState());

    const actionPromise = promise(client);

    return actionPromise
      .then(
        payload => {
          next({ ...rest, payload, type: SUCCESS });

          onSuccessDispatched(payload, rest, dispatch, getState());
        },
        payload => {
          next({ ...rest, payload, type: FAILURE });

          onFailureDispatched(payload, rest, dispatch, getState());
        }
      )
      .catch(error => {
        debug('MIDDLEWARE ERROR:', error);
        notify(error);
        next({ ...rest, error, type: FAILURE });
        onFailureDispatched(error, rest, dispatch, getState());
      });
  };
}
